import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import canUseDOM from '../../../util/can-use-dom';

const propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  onLoad: PropTypes.func,
  onError: PropTypes.func,
  className: PropTypes.string,
};

const defaultProps = {
  onLoad: () => {},
  onError: () => {},
};

const ProgressiveImage = ({
  src,
  alt = '',
  onLoad,
  onError,
  className,
  ...props
}) => {
  // If we're server side rendering we always want to start as if loaded.
  const [loaded, setLoaded] = useState(!canUseDOM);

  const onImageLoaded = () => {
    setLoaded(true);
  };

  const classes = classNames({
    'progressive-image': true,
    'is-loaded': loaded,
    [className]: !!className,
  });

  return (
    <img
      className={classes}
      src={src}
      alt={alt}
      {...props}
      onLoad={onImageLoaded}
      onError={onError}
    />
  );
};

ProgressiveImage.propTypes = propTypes;
ProgressiveImage.defaultProps = defaultProps;

export default ProgressiveImage;
